module.exports = __webpack_public_path__ + "img/ers.57c009db.jpg";